import { DateString } from 'types'
import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/entries/rolodexEntryFields'
import { parseDate, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export type GeckoWalkdownJSON = {
  name?: string
  start_date: DateString
  lead: string
  site_entrance_location?: string
  emergency_rendezvous_location?: string
  point_of_contact?: {
    name: string
    phone_number?: string
  }
}

export class GeckoWalkdown extends GeckoEntryBase<
  {
    name?: string
    startDate: Date | undefined
    lead: string
    siteEntranceLocation?: string
    emergencyRendezvousLocation?: string
    pointOfContact?: {
      name: string
      phoneNumber?: string
    }
  },
  { organization: string; site: string }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        name: parseString(json.data.name),
        startDate: parseDate(json.data.start_date),
        lead: parseString(json.data.lead) ?? 'unknown',
        siteEntranceLocation: parseString(json.data.site_entrance_location),
        emergencyRendezvousLocation: parseString(
          json.data.emergency_rendezvous_location
        ),
        pointOfContact:
          !!json.data.point_of_contact &&
          typeof json.data.point_of_contact === 'object'
            ? {
                name:
                  'name' in json.data.point_of_contact
                    ? (parseString(json.data.point_of_contact.name) ?? '')
                    : '',
                phoneNumber:
                  'phone_number' in json.data.point_of_contact
                    ? (parseString(json.data.point_of_contact.phone_number) ??
                      '')
                    : '',
              }
            : undefined,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson): GeckoWalkdown {
    return new GeckoWalkdown(json)
  }
}

export type WalkdownReportLink = GeckoEntryBase<
  Record<string, unknown>,
  {
    organization: string
    site: string
    [RolodexEntryType.WALKDOWN]: string
    [RolodexEntryType.REPORT]: string
  }
>
export type WalkdownUnitLink = GeckoEntryBase<
  Record<string, unknown>,
  {
    organization: string
    site: string
    [RolodexEntryType.WALKDOWN]: string
    [RolodexEntryType.UNIT]: string
  }
>

export type WalkdownEntry = {
  entry: GeckoWalkdownJSON
}
